import { TemplateMacroToolbarProps } from '@/template/interface'
import { getFormatMessage } from '@/utils/utils'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Form, Input, Space } from 'antd'
import React from 'react'

export const TemplateMacroToolbar: React.FC<TemplateMacroToolbarProps> = (
  props: TemplateMacroToolbarProps
) => {
  const formatMessage = getFormatMessage()
  const [form] = Form.useForm()

  const handleReset = () => {
    form.resetFields()
    if (props.onSearch) {
      props.onSearch(form.getFieldsValue())
    }
  }

  const handleSubmit = () => {
    if (props.onSearch) {
      props.onSearch(form.getFieldsValue())
    }
  }

  return (
    <Form form={form} layout='inline' style={{ marginBottom: 16 }}>
      <Form.Item name='name'>
        <Input
          allowClear={true}
          placeholder={formatMessage({
            id: 'app.template.macro.toolbar.name'
          })}
        />
      </Form.Item>
      <Form.Item>
        <Button type='link' onClick={handleReset}>
          {formatMessage({
            id: 'app.template.macro.toolbar.clear'
          })}
        </Button>
        <Button type='primary' onClick={handleSubmit} icon={<SearchOutlined />}>
          {formatMessage({
            id: 'app.template.macro.toolbar.search'
          })}
        </Button>
      </Form.Item>
      <Form.Item style={{ marginLeft: 'auto' }}>
        <Space align='end'>
          <Button type='primary' onClick={props.onCreate}>
            {formatMessage({ id: 'app.template.macro.toolbar.create' })}
          </Button>

          <Button
            type='primary'
            disabled={!props.selectable}
            onClick={props.onBatchDelete}
          >
            {formatMessage({ id: 'app.template.macro.toolbar.batchDelete' })}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  )
}
